jQuery(function($) {

    // HAMBURGER MENU
    // --------------
    $('.m-hamburger').click(function() {
        $(this).toggleClass('is-open');
    });

    // ADD DATA-VALIDATION ATTRIBUTES TO CF7 INPUT
    // -------------------------------------------
    $('.wpcf7-validates-as-required[type=text]').attr('data-validation', 'required');

    $('.wpcf7-validates-as-required[type=email]').attr('data-validation', 'email');

    $('.wpcf7-validates-as-required[type=url]').attr('data-validation', 'url');

    $('.wpcf7-validates-as-required[type=tel]').attr('data-validation', 'number');

    $('.wpcf7-validates-as-required[type=number]').attr('data-validation', 'number');

    $('.wpcf7-validates-as-required[type=date]').attr('data-validation', 'date');

    $('textarea.wpcf7-validates-as-required').attr('data-validation', 'required');

    $('select.wpcf7-validates-as-required').attr('data-validation', 'required');

    $('.wpcf7-validates-as-required input[type=checkbox]').attr('data-validation', 'required');
    $('.wpcf7-validates-as-required[type=checkbox]').attr('data-validation', 'required');

    $('.wpcf7-validates-as-required[type=file]').attr('data-validation', 'required');


    // INIT JQUERY FORM VALIDATOR
    // --------------------------
    var ita = {
        errorTitle : 'Invio della richiesta fallito!',
        requiredFields : 'Questo campo è obbligatorio',
        badTime : 'Non hai inserito un orario corretto',
        badEmail : 'L\'indirizzo email non è corretto',
        badTelephone : 'Non hai inserito un numero di telefono corretto',
        badSecurityAnswer : 'Non hai dato una risposta esatta alla domanda di sicurezza',
        badDate : 'Non hai inserito una data corretta',
        lengthBadStart : 'Devi inserire una risposta tra ',
        lengthBadEnd : ' caratteri',
        lengthTooLongStart : 'Non hai dato una risposta più lunga di ',
        lengthTooShortStart : 'Non hai dato una risposta più corta di ',
        notConfirmed : 'I valori non possono essere confermati',
        badDomain : 'Valore di dominio non corretto',
        badUrl : 'La tua risposta non è un URL corretto',
        badCustomVal : 'Hai dato una risposta non corretts',
        badInt : 'La risposta che hai dato non è un numero corretto',
        badSecurityNumber : 'Il tuo numero di sicurezza non è corretto',
        badUKVatAnswer : 'Numero UK VAT non corretto',
        badStrength : 'La password non è abbastanza sicura',
        badNumberOfSelectedOptionsStart : 'Devi scegliere almeno ',
        badNumberOfSelectedOptionsEnd : ' risposte',
        badAlphaNumeric : 'La risposta deve contenere solo caratteri alfanumerici ',
        badAlphaNumericExtra: ' e ',
        wrongFileSize : 'Il file che vuoi caricare è troppo grande',
        wrongFileType : 'Il file che vuoi caricare non è del tipo corretto',
        groupCheckedRangeStart : 'Scegli tra ',
        groupCheckedTooFewStart : 'Scegli almeno ',
        groupCheckedTooManyStart : 'Scegli un massimo di ',
        groupCheckedEnd : ' campo/i'
    };

    $.validate({
        form: ".wpcf7-form",
        language: ita,
        borderColorOnError : '',
        onSuccess : function(form) {

            // Tracking con Google Tag Manager
            // Nota: solo nella form Contatti della pagina Contatta il progettista
            var formId = $(form[0]).parents(".wpcf7").attr("id");
            if (formId == "wpcf7-f25440-p25416-o1") {
                var prjName = $("h1.heading").text();
                if (typeof dataLayer === "object") {
                    dataLayer.push({
                        'event': 'form-contatta-progettista',
                        'progettista': prjName
                    });
                }
                else {
                    console.log("dataLayer.push({ 'event': 'form-contatta-progettista', 'progettista': "+prjName+" });");
                }
            }

            var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
            location.assign(thankyouURL);
        },
    });

    // INIT AJAXFORM ON CF7 FORMS
    // --------------------------
    $('.wpcf7-form').ajaxForm();

});
